module.exports = "/_next/static/images/e821a6564497a8a5a1085748bff593d2-nuconta-inclined-device@3x.png";